
import { NavItem } from "@school/a2z-lib";
import { environment } from '../../../environments/environment'


export const MenuItems: NavItem[] = [
  {
    title: 'Teleconsult',
    subtitle: 'Create & Join Video Consult',
    status: '',
    icon: './assets/media/svg/icons/a2z/video-conference.svg',
    urlLink: '/'+environment.apiVersion+'/teleconsult',
  },
];
